import { render, staticRenderFns } from "./gird.vue?vue&type=template&id=5dcd1e3e&scoped=true&"
import script from "./gird.vue?vue&type=script&lang=js&"
export * from "./gird.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5dcd1e3e",
  null
  
)

export default component.exports